import React, { useRef } from 'react'
import { URL_S3 } from '../../../../config/BaseUrl'

function All({ galleryItems, fullScreen }) {

  const allItemBody = useRef(null)


  return (
    <div className="video-items section-items" ref={allItemBody} onDoubleClick={e=>fullScreen(allItemBody)} data-title="Double click to open in fullscreen mode">
      <div id="allItems" className="carousel slide carousel-fade" data-ride="carousel">
        <div className="carousel-inner">
          {
            galleryItems &&
              galleryItems.length > 0 ?
              galleryItems.map((item, index) => (
                item.media_type === 'video' || item.media_type === 'boomerang' ?
                  <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={`video-key-${index}`}>
                    <video width="480px" height={"100%"} className="pr-2 pr-md-0" poster={URL_S3 + 'event_gallery/photo/' + item.event_photo} controls>
                      <source src={URL_S3 + 'event_gallery/video/' + item.event_video} type="video/mp4" />
                    </video>
                  </div>
                  :
                  <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={`photo-key-${index}`}>
                    <img src={URL_S3 + 'event_gallery/photo/' + item.event_photo} className="img-fluid" alt="images" />
                  </div>
              ))
              :
              <div className="carousel-item active">
                <div className="empty-content">
                  <p className="text-center text-white">There is no items to show</p>
                </div>
              </div>
          }
        </div>
        <a className="carousel-control-prev" href="#allItems" role="button" data-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="sr-only">Previous</span>
        </a>
        <a className="carousel-control-next" href="#allItems" role="button" data-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="sr-only">Next</span>
        </a>
      </div>
    </div>
  )
}

export default All
